import { render } from "./bluePaintBlock.vue?vue&type=template&id=5aa673a3&ts=true"
import script from "./bluePaintBlock.vue?vue&type=script&lang=ts"
export * from "./bluePaintBlock.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__